import {observable, action, runInAction} from 'mobx'
import alertMessage from '../utils/alertMessage'
import fatigueConfigAPI from '../apis/fatigueConfigAPI'

export default class fatigueConfigStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable fatigueValue = {}
  @observable groupInfoList = []

  @action
  async getFatigueValue() {
    this.isFetching = true
    try {
      const response = await fatigueConfigAPI.getFatigueValue()
      runInAction(() => {
        const {data} = response
        this.isFetching = false
        if (data.code === 0) {
          this.fatigueValue = data?.data.fatigueValueRule || {}
          this.groupInfoList = data?.data.groupInfoList || []
        } else {
          alertMessage.error('Failed！' + data.message + '')
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async modifyFatigueValue(params) {
    this.isFetching = true
    try {
      const response = await fatigueConfigAPI.modifyFatigueValue(params)
      runInAction(() => {
        const {data} = response
        this.isFetching = false
        if (data.code === 0) {
          alertMessage.success('保存成功')
        } else {
          alertMessage.error('Failed！' + data.message + '')
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async modifyGroupMode(record, field, value) {
    this.isFetching = true
    try {
      this.groupInfoList = this.groupInfoList.map(item =>
        item.id === record.id ? {...item, [field]: +value} : item
      )
      const updatedItem = this.groupInfoList.find(item => item.id === record.id)
      const params = {
        'isAdminMode': updatedItem.isAdminMode,
        'isPrivilegedMode': updatedItem.isPrivilegedMode,
        'marketGroupId': updatedItem.id
      }
      const response = await fatigueConfigAPI.modifyGroupMode(params)
      runInAction(() => {
        const {data} = response
        this.isFetching = false
        if (data.code === 0) {
          alertMessage.success('保存成功')
        } else {
          alertMessage.error('Failed！' + data.message + '')
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
}
